<template>
	<div class="head">
		<div class="head-main">
			<img :src="special == null ?  'https://img.aierxin.cn/logo/logo.png' : special.logo_path" :style="special != null? 'width: 80px; height: 80px' : ''"  />
<!--			<img :src="special == null ?  'https://img.aierxin.cn/logo/logo.png' : special.logo_path" style="width: 80px; height: 80px"  v-if="special == null"/>-->

<!--      <img src="../assets/img/logo.png" v-else/>-->
			<div class="head-navList">
				<div v-for="item in nav" :key="item.id" class="head-nav" :class="item.className"
					@click="handleLink(item)">
					{{ item.name }}
				</div>
				<!-- <div
          class="head-nav"
          :class="{ 'head-nav-active': navTab == 1 }"
          @click="goCurriculumSetMeal"
        >
          课程中心
        </div>
        <div
          class="head-nav"
          :class="{ 'head-nav-active': navTab == 2 }"
          @click="goExamination"
        >
          考试
        </div>
        <div
          class="head-nav"
          :class="{ 'head-nav-active': navTab == 3 }"
          @click="handleToHome('/news', 3)"
        >
          新闻资讯
        </div>-->
			</div>
			<div class="head-box head-address">
				<Poptip width="360" trigger="hover">
<!--					<img src="../assets/img/icn1.png" />-->
<!--					<span>{{ cityName }} ▼</span>-->
<!--					<div slot="content">-->
<!--						<div class="head-city">-->
<!--							&lt;!&ndash;  @on-change="gcity1" &ndash;&gt;-->
<!--							<Select class="ExaminationIdentityOk-city" style="width: 150px;" v-model="cityId2"-->
<!--								@on-change="gcity1" placeholder="云南">-->
<!--								&lt;!&ndash;  v-for="i in city" &ndash;&gt;-->
<!--								<template>-->
<!--									<Option value="530000">云南</Option>-->
<!--								</template>-->
<!--							</Select>-->
<!--							<Select class="ExaminationIdentityOk-city" style="width: 150px;" v-model="cityId3"-->
<!--								@on-change="gcity2" placeholder="城市">-->
<!--								<template v-for="i in city2">-->
<!--									<Option :value="i.id">{{ i.name }}</Option>-->
<!--								</template>-->
<!--							</Select>-->
<!--						</div>-->
<!--						<div class="head-city-title">区/县:</div>-->
<!--						<div class="head-city-list">-->
<!--							<template v-for="i in city3">-->
<!--								<span @click="cityStr(i.name)">{{ i.name }}</span>-->
<!--							</template>-->
<!--						</div>-->
<!--					</div>-->
				</Poptip>
			</div>

			<div v-if="!master.token.token || list.length <= 0" class="head-box" style="margin-right:57px"
				@click="handleToMessage">
				<img style="margin-right:7px" src="../assets/img/icn2.png" />
				<span>消息</span>
			</div>
			<Poptip v-if="master.token.token && list.length > 0" trigger="hover" width="260" class="head-msg"
				placement="bottom-end">
				<div class="head-box" @click="handleToMessage('List')">
					<img src="../assets/img/icn2.png" />
					<span>消息</span>
				</div>

				<div slot="content">
					<div class="head-bar-msg" v-for="item in list" :key="item.id" @click="handleToMsgDetail(item.id)">
						<span class="span1">{{ item.title }}</span>
						<span class="span2">{{ item.time }}</span>
					</div>
				</div>
			</Poptip>
			<div class="studyCenter" @click="toStudy">学习中心</div>
			<Poptip width="120" v-if="master.user.username" trigger="hover" placement="bottom-start">
				<div class="head-bar head-bar2" @click="handleToUserCenter">
					<span class="head-bar-name">{{ master.user.name }}</span>
					<img src="../assets/img/topicn.png" />
				</div>
				<div slot="content">
					<div class="head-bar-item" @click="goUserSet">设置</div>
					<div class="head-bar-item" @click="loginOut">退出</div>
				</div>
			</Poptip>
			<div class="head-bar" v-else>
				<span class="s1" @click="
            loginFlag = true;
            loginNav = 'name1';
          ">登录</span>
        <a href=""></a>
				<span class="s2" v-if="special == null" >|</span>
				<span class="s3" v-if="special == null" @click="
            loginFlag = true;
            loginNav = 'name2';
          ">注册</span>
			</div>
		</div>
<!--    <Modal-->
<!--        v-model="showModal"-->
<!--        title="温馨提示"-->
<!--        @on-ok="showModal = false"-->
<!--        :mask-closable = 'false'-->
<!--        :closable="false"-->
<!--        ok-text="已熟知"-->
<!--        @on-cancel="showModal = false">-->
<!--      <p>欢迎进入爱尔信网络继续教育学习平台，请您务必于2023年12月31日前完成学习且考试合格。</p>-->
<!--    </Modal>-->
		<Modal v-model="loginFlag" width="400" :closable="false" :mask-closable="false"
			class-name="vertical-center-modal">
			<!-- <div class="head-login-title">登录1</div>
      <Form
        class="head-login"
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="80"
      >
        <FormItem label="用户名" prop="name">
          <Input v-model="formValidate.name" placeholder="身份证号"></Input>
        </FormItem>
        <FormItem label="密码" prop="pw">
          <Input
            v-model="formValidate.pw"
            type="password"
            placeholder="请输入密码（初始密码身份证后6位）"
          ></Input>
        </FormItem>
      </Form>
      <div class="head-login-btn" @click="login">登录</div>
      <div class="head-login-bar">
        <Checkbox v-model="autoLoginBtn">下次自动登录</Checkbox>
        <span @click="goRetrievePw">忘记密码？</span>
      </div> -->
			<Tabs v-model="loginNav">
				<TabPane label="登录" class="login-box" name="name1">
					<Form class="head-login" ref="formValidate" :model="formValidate" :rules="ruleValidate"
						:label-width="80">
						<FormItem label="用户名" prop="name">
							<Input v-model="formValidate.name" placeholder="身份证号"></Input>
						</FormItem>
						<FormItem label="密码" prop="pw">
							<Input v-model="formValidate.pw" type="password" placeholder="请输入密码(初始密码身份证后6位或123456)"></Input>
						</FormItem>
					</Form>
					<div class="head-login-btn" @click="login">登录</div>
					<div class="head-login-bar">
						<!-- <Checkbox v-model="autoLoginBtn">下次自动登录</Checkbox> -->
						<span @click="goRetrievePw">忘记密码？</span>
					</div>
					<!-- <div class="head-other">其他登录方式</div> -->
				</TabPane>
				<TabPane label="注册" name="name2" v-if="special == null" >
					<Form class="head-login" ref="formValidate2" :model="formValidate2" :rules="ruleValidate2"
						:label-width="120">
						<FormItem label="姓名" prop="name">
							<Input v-model="formValidate2.name" placeholder="请输入用户名"></Input>
						</FormItem>
						<FormItem label="身份证号码" prop="PersonalCode">
							<Input v-model="formValidate2.PersonalCode"  placeholder="请输入身份证号码"></Input>
						</FormItem>
						<FormItem label="所在城市" prop="city">
							<Select v-model="formValidate2.city" placeholder="请选择所在城市" @on-change="handleChangeTypeCity">
								<Option v-for='(item,index) in cityList' :value="item.cityid">{{item.city}}</Option>
							</Select>
						</FormItem>
						<FormItem label="所在区" prop="area" >
							<Select v-model="formValidate2.area" placeholder="请选择所在区" @on-change="handleChangeTypeQu">
								<Option v-for='(item,index) in areaList' :value="item.areaid">{{item.area}}</Option>
							</Select>
						</FormItem>
						<FormItem label="手机号码" prop="phone">
							<Input v-model="formValidate2.phone" style="margin-bottom: 10px;"
								placeholder="手机号码"></Input>
						</FormItem>
						<FormItem class="code" ref="code" label="短信验证码" prop="code">
							<div class="display-flex" style="width:288px">
								<Input v-model="formValidate2.code" placeholder="请输入验证码"></Input>
								<div class="send">
									<Button :disabled="btnDisabled" type="primary"
										@click="handleSendCode('from')">{{ codeBtnText }}</Button>
								</div>
							</div>
						</FormItem>
						<!-- <div class="head-login-code" @click="getCode" slot="append">
							{{ codeTest }}
						</div>
						</Input> -->
					</Form>
					<div class="head-login-btn" style="margin-top: 30px;" @click="register"  v-if="special == null" >注册</div>
					<div class="head-login-bar2">
						<Checkbox v-model="agreementBtn"></Checkbox>
						<span>《用户使用协议》</span>
					</div>
				</TabPane>
			</Tabs>
			<img class="head-login-close" @click="close" src="../assets/img/close.png" />
			<div slot="footer">
				<!--<img class="head-wecaat" v-if="loginNav == 'name1'" src="../assets/img/wecaat.png" />-->
			</div>
		</Modal>
	</div>
</template>

<script>
	import * as api from "@/assets/api/api.js";
	import {
		EventBus,
		postData,
		postDataNew
	} from "../assets/api/api";
	export default {
		name: "Head",
		components: {},
		data() {
			return {
				nav: [{
						id: 0,
						name: "首页",
						className: "head-nav-active",
						url: "/",
					},
					{
						id: 1,
						name: "课程中心",
						className: "",
						url: "/CurriculumSetMeal",
					},
					// {
					// 	id: 2,
					// 	name: "考试",
					// 	className: "",
					// 	url: "/Examination",
					// },
					// {
					// 	id: 3,
					// 	name: "新闻资讯",
					// 	className: "",
					// 	url: "/news",
					// },
				],
				list: [],
				navTab: 0,
        showModal:true,
				loginFlag: false,
				codeBtnText: "点击发送",
				formValidate: {
          name:"",
          pw:"",
					// name: "530111197203020846",//530324198510202137 530111197203020846
					// pw: "020846",//020846
				},
				loginNav: "name2",
				ruleValidate: {
					name: [{
						required: true,
						message: "请输入身份证号",
						trigger: "blur",
					}, ],
					pw: [{
						required: true,
						message: "请输入密码",
						trigger: "blur",
					}, ],
				},
				btnDisabled:false,
				formValidate2: {
					name:'',
					PersonalCode:'',
					city:'',
					area:'',
					phone:'',
					code:'',
				},
				ruleValidate2: {
					name: [{
						required: true,
						message: "请输入用户名",
						trigger: "blur",
					}, ],
					PersonalCode: [{
							required: true,
							message: "请输入身份证号码",
							trigger: "blur"
						},
						{
							pattern: /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/,
							message: "身份证号码格式不对",
						},
					],
					city: [{
						required: true,
						message: "请选择所在城市",
						// trigger: "blur"
					}],
					area: [{
						required: true,
						message: "请选择所在区",
						// trigger: "blur"
					}],
					phone: [{
							required: true,
							message: "手机号码不能为空",
							trigger: "blur"
						},
						// {
						// 	pattern: /^((\+86)|(86))?1[34578][0-9]\d{8}$/,
						// 	message: "手机号码格式不对",
						// },
					],
					code: [{
						required: true,
						message: "请输入验证码",
						trigger: "blur",
					}, ],
				},
				autoLoginBtn: false,
				agreementBtn: false,
				codeTest: "点击发送",
				codeBtn: true,
				city: [],
				city2: [],
				city3: [],
				cityId2: "530000",
				cityId3: "",
				cityName: "云南省-昆明市",
				cityList:[],
				cityNewname:'',
				quNewName:'',
				areaList:[],
        special:null,
			};
		},
		watch: {
			$route(val) {
				var url = val.path;
				this.nav.map((i) => {
					if (
						url == "/CurriculumSetMealInfo" ||
						url == "/OrderOk" ||
						url == "/Pay" ||
						url == "/CurriculumVideo" ||
						url == "/Curriculum"
					) {
						if (i.name == "课程中心") {
							i.className = "head-nav-active";
						} else {
							i.className = "";
						}
					} else if (
						url == "/ExaminationIdentity" ||
						url == "/ExaminationInfo" ||
						url == "/ExaminationResult" ||
						url == "/ExaminationBook"
					) {
						if (i.name == "考试") {
							i.className = "head-nav-active";
						} else {
							i.className = "";
						}
					} else if (url == "/newsDetail") {
						if (i.name == "新闻资讯") {
							i.className = "head-nav-active";
						} else {
							i.className = "";
						}
					} else if (i.url == url) {
						i.className = "head-nav-active";
					} else {
						i.className = "";
					}
				});
			},
		},
		created() {
      postDataNew("/jxjyapi/tenpoint/indexMsgNew").then(res=>{
            if(res.data.msg != null){
              this.$Modal.success({
                title: '温馨提示',
                content: res.data.msg,
                okText:'已熟知'
              });
            }
          }
      )

     this.special = JSON.parse(localStorage.getItem("special"))
      if (this.special  != null){
        this.nav = [{
          id: 0,
          name: "首页",
          className: "head-nav-active",
          url: "/",
        },
          {
            id: 2,
            name: "考试",
            className: "",
            url: "/Examination",
          },
          {
            id: 3,
            name: "新闻资讯",
            className: "",
            url: "/news",
          },
        ]
      }




			if (localStorage.getItem("master")) {
				this.$store.commit(
					"setMaster",
					JSON.parse(localStorage.getItem("master"))
				);
			} else if (sessionStorage.getItem("master")) {
				this.$store.commit(
					"setMaster",
					JSON.parse(sessionStorage.getItem("master"))
				);
			}
			if (sessionStorage.getItem("navTab")) {
				this.navTab = sessionStorage.getItem("navTab");
			}
			this.formValidate2.area = Number('');
			api.EventBus.$on("login", () => {
				this.loginFlag = true;
				this.loginNav = "name1";
			});
			api.EventBus.$on("register", () => {
				// window.location.href = 'https://jxjy.aierxin.cn/member/login/reg.html';
				this.loginFlag = true;
				this.loginNav = "name2";
			});
			api.EventBus.$on("loginOut", () => {
				this.loginOut();
			});
			api.EventBus.$on("changeNav", (res) => {
				this.navTab = res;
			});
			api.EventBus.$on("redirectHome", (res) => {
				this.navTab = 0;
				this.$router.push({
					path: "/",
				});
				this.$store.commit("setMaster", {
					user: {
						username: "",
					},
					token: {
						token: "",
					},
				});
			});
			this.gcity1();
			this.cityLists();
		},
		mounted() {},
		computed: {
			master() {
				if (this.$store.state.master.token.token) {
					this.loadMsgData();
				}
				return this.$store.state.master;
			},
		},
		methods: {
			handleLink(item) {
				if (item.url == "/CurriculumSetMeal" || item.url == "/Examination") {
					if (!this.master.token.token) {
						this.loginFlag = true;
						this.loginNav = "name1";
						this.$Message.warning("请登录");
						return;
					}
				}
				if (item.url == "/Examination") {
					if (!this.$store.state.master.user.phone) {
						this.$Message.warning("请先绑定手机号码");
						this.$router.push({
							path: "/bindPhone",
						});
					} else {
						this.$router.push({
							path: item.url
						});
					}
				} else {
					this.$router.push({
						path: item.url
					});
				}
				this.nav.forEach((i) => {
					if (item.id == i.id) {
						i.className = "head-nav-active";
					} else {
						i.className = "";
					}
				});
			},
			goCurriculumSetMeal() {
				if (!this.master.token.token) {
					this.loginFlag = true;
					this.loginNav = "name1";
					this.$Message.warning("请登录");
					return;
				}
				this.navTab = 1;
				sessionStorage.setItem("navTab", 1);
				this.$router.push({
					name: "CurriculumSetMeal",
				});
			},
			goExamination() {
				if (!this.master.token.token) {
					this.loginFlag = true;
					this.loginNav = "name1";
					this.$Message.warning("请登录");
					return;
				}
				this.navTab = 2;
				sessionStorage.setItem("navTab", 2);
				this.$router.push({
					name: "Examination",
				});
			},
			handleToUserCenter() {
				this.$router.push({
					path: "/attendanceProcess/combo",
				});
			},
			goRetrievePw() {
				this.loginFlag = false;
				this.$router.push({
					name: "retrievePw",
				});
			},
			loadMsgData() {
				var params = {
					currentPage: 0,
					pageSize: 4,
				};
				postData("notify/listNotifyPage", params).then((res) => {
					if (res.data) {
						if (res.data.entities.length > 0) {
							res.data.entities.map((i) => {
								var time = i.createTime.split(" ")[0].split("-");
								i.time = `${time[1]}-${time[2]}`;
								return i;
							});

							this.list = res.data.entities;
							this.totalPage = res.data.pageCount;
						} else {
							this.list = [];
						}
					} else {
						this.list = [];
					}
				});
			},
			cityLists(){
				postDataNew("/jxjyapi/login/cityList").then((res) => {
					this.cityList = res.data.list.filter(item => item.is_show == 1);
					console.log(this.cityList);
				});
			},
			getAreaList(){
				var params ={
					city:this.formValidate2.city,
				}
				postDataNew("/jxjyapi/login/getAreasList",params).then((res) => {
					this.areaList = res.data.list;
					console.log(this.areaList);
				});
			},
			handleChangeTypeCity(val) {
				this.formValidate2.city = val;
				console.log(this.formValidate2.city);
				this.getAreaList();
			},
			getArea(){
				console.log('1212',this.formValidate2.city);
				if(this.formValidate2.city == ''){
					this.$Message.error("请先选择所在城市");
					return
				}
			},
			handleChangeTypeQu(val) {
				
				if(this.formValidate2.city != ''){
					this.formValidate2.qu = val;
				}else{
					this.$Message.error("请先选择所在城市");
					return
				}
				
				// console.log(this.formValidate2.qu);
			},
			//去学习中心
			toStudy() {
				if (!this.master.token.token) {
					this.loginFlag = true;
					this.loginNav = "name1";
					this.$Message.warning("请登录");
					return;
				}
				this.$router.push({
					path: "/attendanceProcess/combo"
				})
			},
			handleToMsgDetail(id) {
				if (!this.master.token.token) {
					this.$Message.warning("请先登录");
				} else {
					this.$router.push({
						path: "/message/msgDetail",
						query: {
							id,
						},
					});
					this.navTab = 10;
					sessionStorage.setItem("navTab", 10);
				}
			},
			handleToMessage() {
				if (!this.master.token.token) {
					this.$Message.warning("请先登录");
					api.EventBus.$emit("login");
				} else {
					this.$router.push({
						path: "/message/msgList",
					});
					this.navTab = 10;
					sessionStorage.setItem("navTab", 10);
				}
			},

			goUserSet() {
				this.$router.push({
					path: "/userSet/setMyInfo",
				});
			},

			handleToHome(url, i) {
				this.navTab = i;
				sessionStorage.setItem("navTab", i);
				this.$router.push({
					path: url,
				});
			},
			login() {
				this.$refs.formValidate.validate((valid) => {
					if (valid) {
						api.showLoading();
						api
							.postData("student/login", {
								username: this.formValidate.name,
								password: this.formValidate.pw,
							})
							.then((res) => {
								if (this.autoLoginBtn) {
									localStorage.setItem("master", JSON.stringify(res.data));
								} else {
									sessionStorage.setItem("master", JSON.stringify(res.data));
								}
								api.EventBus.$emit("loadUserInfo");
								this.$store.commit("setMaster", res.data);
								console.log(res.data);
								this.loginFlag = false;
								this.loadMsgData();
								if (!res.data.user.phone) {
									this.$router.push({
										name: "bindPhone",
									});
								}
							});
					}
				});
			},
			register() {
				
				if (!this.formValidate2.name) {
					this.$Message.error("请填写姓名");
					return;
				}
				if (!this.formValidate2.PersonalCode) {
					this.$Message.error("请填写身份证号码");
					return;
				}
				if (!this.formValidate2.city) {
					this.$Message.error("请选择所在城市");
					return;
				}
				if (!this.formValidate2.area) {
					this.$Message.error("请选择区");
					return;
				}
				if (!this.formValidate2.code) {
					this.$Message.error("请填写验证码");
					return;
				}
				// if(!this.agreementBtn){
				// 	this.$Message.error("请勾选用户使用协议");
				// 	return;
				// }
				this.$refs.formValidate2.validate((valid) => {
					if (valid) {
						var params ={
							identity_card: this.formValidate2.PersonalCode,
							name: this.formValidate2.name,
							mobile: this.formValidate2.phone,
							code: this.formValidate2.code,
							city:this.formValidate2.city,
							area:this.formValidate2.area,
						}
						postDataNew("/jxjyapi/login/register",params).then((res) => {
              console.log(res)
              if (res.status == 1){

                this.$Notice.success({
                  title: "恭喜您注册成功",
                });
                this.loginFlag = true;
                this.loginNav = 'name1';
              }else {
                this.$Notice.error({
                  title: res.msg,
                });
              }

							
						});
							
					}
				});
			},
			loginOut() {
				api
					.postData("student/logout", {}, () => {
						this.$Notice.success({
							title: "退出成功",
						});
						localStorage.removeItem("master");
						sessionStorage.removeItem("master");
						this.$store.commit("setMaster", {
							user: {
								username: "",
							},
							token: {
								token: "",
							},
						});
						api.EventBus.$emit("getToten");
						this.$router.replace("/");
						api.EventBus.$emit("login");
					})
					.then((res) => {
						this.$Notice.success({
							title: "退出成功",
						});
						localStorage.removeItem("master");
						sessionStorage.removeItem("master");
						this.$store.commit("setMaster", {
							user: {
								username: "",
							},
							token: {
								token: "",
							},
						});
						api.EventBus.$emit("getToten");
						this.$router.replace("/");
						api.EventBus.$emit("login");
					});
			},
			handleSendCode() {
				// this.$refs.formValidate2.validate("phone", (valid) => {
					if (this.formValidate2.phone != '') {
						var params ={
							mobile: this.formValidate2.phone,
							type: 1,
						}
						postDataNew("/jxjyapi/login/sendCommonMsg",params).then((res) => {
							this.$Message.success("发送成功,请注意查收");
							var time = 60;
							this.codeBtnText = time + "s后重发";
							var timer = setInterval(() => {
								if (time <= 0) {
									clearInterval(timer);
									this.codeBtnText = "点击发送";
									this.btnDisabled = false;
									return;
								}
								time--;
								this.codeBtnText = time + "s后重发";
								this.btnDisabled = true;
							}, 1000);
						});
						
					} else {
						this.$Message.warning("请输入手机号码");
					}
				// });
			},
			close() {
				this.loginFlag = false;
			},
			getCity(id) {
				api
					.postData("area/list", {
						id: id || "",
					})
					.then((res) => {
						this.city = res.data;
					});
			},
			gcity1() {
				api
					.postData("area/list", {
						id: this.cityId2,
					})
					.then((res) => {
						this.city2 = res.data;
					});
			},
			gcity2() {
				if (!this.cityId3) {
					this.city3 = [];
					return;
				}
				api
					.postData("area/list", {
						id: this.cityId3,
					})
					.then((res) => {
						this.city3 = res.data;
						if (res.data.length == 0) {
							let sheng, shi;
							for (let i of this.city) {
								if (i.id == this.cityId2) {
									sheng = i.name;
								}
							}
							for (let i of this.city2) {
								if (i.id == this.cityId3) {
									shi = i.name;
								}
							}
							this.cityName = sheng + "-" + shi;
						}
					});
			},
			cityStr(i) {
				let sheng = "云南",
					shi;
				for (let i of this.city) {
					if (i.id == this.cityId2) {
						sheng = i.name;
					}
				}
				for (let i of this.city2) {
					if (i.id == this.cityId3) {
						shi = i.name;
					}
				}
				this.cityName = sheng + "-" + shi + "-" + i;
			},
		},
	};
</script>

<style lang="scss">
	// .ivu-modal-wrap {
	//   overflow: visible !important;
	//   top: 50% !important;
	//   left: 50% !important;
	//   transform: translate(-50%, -200px) !important;
	//   -ms-transform: translate(-50%, -200px) !important; /* IE 9 */
	//   -webkit-transform: translate(-50%, -200px) !important; /* Safari and Chrome */
	// }
	//学习中心样式
	.studyCenter {
		width: 80px;
		height: 20px;
		background: rgba(49, 175, 88, 1);
		border-radius: 10px;
		margin-right: 10px;
		text-align: center;
		line-height: 20px;
		font-size: 14px;
		color: #FFFFFF;
		cursor: pointer;
	}

	.head {
		background: #222222;

		.ivu-poptip-body {
			padding: 2px;
		}

		&-main {
			width: 1200px;
			height: 80px;
			margin: 0 auto;
			display: flex;
			align-items: center;
		}

		&-navList {
			padding: 3px 0;
			display: flex;
			margin-left: 100px;
		}

		&-city {
			display: flex;
			padding: 20px;
			justify-content: space-between;

			&-title {
				margin: 0 20px;
				padding-bottom: 8px;
				font-size: 14px;
				color: #222222;
				border-bottom: 1px solid #eeeeee;
			}

			&-list {
				padding: 16px 30px;
				display: flex;
				flex-wrap: wrap;
				color: #999999;

				span {
					margin-right: 20px;
					margin-bottom: 10px;
				}
			}
		}

		&-nav {
			width: 100px;
			text-align: center;
			font-size: 14px;
			color: #fff;
			line-height: 74px;
			cursor: pointer;
			margin-right: 10px;

			&-active {
				background: #37bd60 !important;
			}
		}

		&-nav:hover {
			background: rgba(55, 189, 96, 0.4);
		}

		&-box {
			display: flex;
			align-items: center;
			font-size: 14px;
			color: #fff;
			cursor: pointer;
		}

		&-address {
			flex: 1;
			justify-content: center;

			.ivu-poptip-rel {
				display: flex;
				align-items: center;
			}
		}

		&-msg {
			margin-right: 57px;
			height: 40px;

			img {
				margin-right: 7px;
			}
		}

		&-bar {
			color: #aaaaaa;
			font-size: 14px;

			&-item {
				height: 40px;
				line-height: 40px;
				text-align: center;
				color: #666666;
				font-size: 14px;
				cursor: pointer;
			}

			&-item:hover {
				background: #eeeeee;
			}

			&-msg {
				height: 40px;
				color: #222222;
				font-size: 14px;
				cursor: pointer;
				display: flex;
				align-items: center;
				padding: 0 10px;

				.span1 {
					flex: 1;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.span2 {
					color: #999999;
				}
			}

			&-msg:hover {
				background: #eeeeee;
			}

			.s1 {
				vertical-align: middle;
				cursor: pointer;
			}

			.s2 {
				margin: 0 10px;
			}

			.s3 {
				vertical-align: middle;
				cursor: pointer;
			}

			&-name {
				font-size: 14px;
				color: #fff;
			}
		}

		&-bar2 {
			display: flex;
			align-items: center;
			cursor: pointer;
		}

		&-login {
			padding: 0 40px;

			&-title {
				font-size: 18px;
				color: #222;
				padding-bottom: 20px;
				border-bottom: 1px solid #f0f1f4;
				margin-bottom: 40px;
			}

			&-btn {
				height: 40px;
				line-height: 40px;
				cursor: pointer;
				background: #37bc5f;
				color: #fff;
				font-size: 14px;
				text-align: center;
				margin: 0 40px;
			}

			&-btn:hover {
				background: rgba(55, 188, 95, 0.7);
			}

			&-bar {
				padding: 0 40px;
				display: flex;
				justify-content: space-between;
				margin-top: 10px;

				span {
					cursor: pointer;
				}

				span:hover {
					color: #37bc5f;
				}
			}

			&-bar2 {
				padding-left: 40px;
				margin-top: 10px;

				span {
					cursor: pointer;
				}

				span:hover {
					color: #37bc5f;
				}
			}

			&-code {
				color: #31af58;
				font-size: 14px;
				cursor: pointer;
				width: 100px;
				line-height: 38px;
				text-align: center;
			}

			&-close {
				position: absolute;
				right: -40px;
				top: -40px;
				cursor: pointer;
			}

			.ivu-input-group-append {
				padding: 0;
			}
		}

		&-other {
			text-align: center;
			margin-top: 66px;
		}

		&-wecaat {
			display: block;
			margin: 0 auto;
		}
	}

	.vertical-center-modal {
		display: flex;
		align-items: center;
		justify-content: center;

		.ivu-modal {
			position: static;
			margin: 0;
		}

		.ivu-tabs-nav {
			left: 60px;
		}

		.ivu-tabs-nav .ivu-tabs-tab {
			font-size: 18px;
			color: #222;
			padding-bottom: 20px;
			width: 120px;
			text-align: center;
		}

		.ivu-tabs-ink-bar {
			background-color: #222222;
		}

		.ivu-form-item-required .ivu-form-item-label:before {
			content: "";
		}

		.ivu-form .ivu-form-item-label {
			float: none;
			display: block;
			text-align: left;
			color: #222222;
			font-size: 14px;
		}

		.ivu-form-item-content {
			margin-left: 0 !important;
		}

		.ivu-input {
			height: 40px;
		}
	}
	.ivu-form-item{
		margin-bottom: 5px !important;
	}
	.login-box {
		display: flex;
		flex-direction: column;
		justify-content: center;
		
	}
	
	.ivu-input-wrapper{
		margin-bottom: 5px;
	}
	.login-box .ivu-form-item-content{
		margin-bottom: 30px;
	}
	.ivu-select-single .ivu-select-selection{
		height: 40px !important;
	}
	.ivu-form-item-content{
		line-height: 40px !important;
	}
	.ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
		height: 40px !important;
		line-height: 40px !important;
	}
	.ivu-form-item-error-tip{
		padding-top: 1px !important;
	}
	.code .ivu-input {
		width: 180px;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}
	.send button {
		height: 36px;
		line-height: 36px;
	}.send .ivu-form-item-content {
		margin-left: 0 !important;
	}

	.phoneBind .send button {
		height: 36px;
	}
</style>